import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Button from '@material-ui/core/Button';
import indigo from '@material-ui/core/colors/indigo';
import { Field, reduxForm } from 'redux-form'
import { connect } from 'react-redux'

const styles = theme => ({
  root: {
    flexGrow: 1
  },
  container: {
    padding: 25,
  },
  containerTop: {
    paddingTop: 0,
    marginTop: -15
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 0,
  },
  center: {
    textAlign: 'center'
  },
  title: {
    color: '#000',
    fontWeight: 500
  },
  enviar: {
    background: indigo['A400'],
    color: 'white'
  }
});

const validate = values => {
  const errors = {}
  const requiredFields = [
    'name',
    'apellido',
    'reason',
    'message'
  ]
  requiredFields.forEach(field => {
    if (!values[field]) {
      errors[field] = 'Required'
    }
  })
  if (
    values.email &&
    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
  ) {
    errors.email = 'Invalid email address'
  }

  return errors
}

const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

const asyncValidate = (values /*, dispatch */) => {
  return sleep(1).then(() => {
    // simulate server latency
    if (['foo@foo.com', 'bar@bar.com'].includes(values.email)) {
      // eslint-disable-next-line no-throw-literal
      throw { email: 'Email already Exists' }
    }
  })
}

const renderTextField = ({
  input,
  label,
  meta: { touched, error },
  children,
  ...custom
}) => {
  return (
    <FormControl fullWidth>
      <TextField
        multiline={input.name === 'message'}
        rows={3}
        placeholder={label}
        error={touched && typeof error !== 'undefined'}
        margin='normal'
        {...input}
        {...custom}
      />
    </FormControl>
  )
}

class ReportTestForm extends React.PureComponent {

  state = {
    name: '',
    apellido: '',
    message: '',
    reason: '',
  };

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    });
  };

  render() {
    const { classes, handleSubmit, pristine, submitting } = this.props;
    return (
      <form onSubmit={handleSubmit}>
        <Grid container>
          <Grid item xs={12}>
            <Field 
              name="first_name"
              component={renderTextField} 
              label='Nombre'
              // value={id}
              // onChange={this.handleChange('name')}
            />

            <Field 
              name="last_name"
              component={renderTextField} 
              label="Primer apellido"
              value={this.state.apellido}
              onChange={this.handleChange('apellido')}
            />

            {/*<FormControl fullWidth>*/}
            {/*  <InputLabel htmlFor="reason">Motivo cancelación</InputLabel>*/}
            {/*  <Select*/}
            {/*    value={this.state.reason}*/}
            {/*    onChange={this.handleChange('reason')}*/}
            {/*    inputProps={{*/}
            {/*      name: 'reason',*/}
            {/*      id: 'reason',*/}
            {/*    }}*/}
            {/*  >*/}
            {/*    <MenuItem value="">*/}
            {/*      <em>None</em>*/}
            {/*    </MenuItem>*/}
            {/*    <MenuItem value={10}>Ten</MenuItem>*/}
            {/*    <MenuItem value={20}>Twenty</MenuItem>*/}
            {/*    <MenuItem value={30}>Thirty</MenuItem>*/}
            {/*  </Select>*/}
            {/*</FormControl>*/}

            <Field
                name="problem"
                component={renderTextField}
                label="Problema"
                value={this.state.message}
                onChange={this.handleChange('message')}
            />

            <Field 
              name="description"
              component={renderTextField} 
              label="Escribe tu problema..."
              value={this.state.message}
              onChange={this.handleChange('message')}
            />

          </Grid>
          <Grid item xs={12} className={classes.center}>
            <Button 
              variant="contained"
              color="primary"
              disabled={pristine || submitting}
              type="submit"
              style={{marginTop: 15}}
            >
              Enviar
            </Button>
          </Grid>
        </Grid>
      </form>

    )
  }
}

ReportTestForm = reduxForm({
  form: 'testReport',
  validate,
  asyncValidate
})(ReportTestForm)

ReportTestForm = connect(state => ({
  auth: state.auth
}))(ReportTestForm)


export default withStyles(styles, {withTheme: true})(ReportTestForm);


// WEBPACK FOOTER //
// ./src/modules/test/components/Forms/ReportTestForm.js